const SHARE_TOKEN_PATTERN = /^[a-f0-9]{64}$/;

export function createShareToken(cryptoApi: Pick<Crypto, "getRandomValues"> = crypto): string {
  const bytes = cryptoApi.getRandomValues(new Uint8Array(32));
  return Array.from(bytes, (value) => value.toString(16).padStart(2, "0")).join("");
}

export function isValidShareToken(token: string): boolean {
  return SHARE_TOKEN_PATTERN.test(token);
}

export async function hashShareToken(token: string): Promise<string> {
  if (!isValidShareToken(token)) throw new Error("Invalid share token.");
  const digest = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(token));
  return Array.from(new Uint8Array(digest), (byte) => byte.toString(16).padStart(2, "0")).join("");
}

export function buildShareUrl(token: string, origin: string): string | null {
  if (!isValidShareToken(token)) return null;
  return new URL(`/s/${token}`, origin).toString();
}
